import React, { useState, Fragment, useEffect } from "react";
import { Button, Dropdown as ReactStrapDropDown } from "reactstrap";
import { SearchBox } from "../SearchBox/SearchBox";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";

import { Mode } from "../../utils/Order/Order";

import style from "./../Offers/style.module.scss";

const Offers = (props) => {
  const { modalOrder, items } = props;
  const { openModalOrder } = modalOrder;
  const [open, setOpen] = useState(false);
  const [itemArray, setItemArray] = useState([]);
  const [state, setState] = useState({
    filters: { text: "" },
  });

  const filterArray = () => {
    if (state.filters.text !== "") {
      let res = [];
      if (items) {
        items.forEach((item) => {
          res.push(item);
        });
      }
      setItemArray(
        res.filter(
          (item) =>
            item.AssetName.toLowerCase().includes(state.filters.text.toLowerCase()) ||
            (item.OfferQuantitytoAdvisor - item.OfferOfferQuantityTakenByAdvisor + "").includes(
              state.filters.text
            ) ||
            (item.OfferPrice + "").includes(state.filters.text)
        ),
        ...res
      );
    } else {
      loadArray();
    }
  };

  const loadArray = () => {
    let res = [];
    if (items) {
      items.forEach((item) => {
        res.push(item);
      });
      setItemArray(res);
    }
  };

  useEffect(() => {
    loadArray();
  }, [items]);

  useEffect(() => {
    filterArray();
  }, [state]);

  const orderSimple = (item) => ({
    AssetId: item.AssetId,
    OrderPrice: item.OfferPrice,
    AssetName: item.AssetName,
    AssetTicker: item.AssetName,
    OrderType: "Limit",
    OrderIsBasket: true ? item.OfferId > 0 : false,
    OrderPrice: item.OfferPrice,
    offer: {
      OfferId: item.OfferId,
      OfferPrice: item.OfferPrice,
      OrderId: item.OrderId,
      OfferQuantitytoAdvisor: item.OfferQuantitytoAdvisor,
      OfferQuantitytoClient: item.OfferQuantitytoClient,
    },
  });

  const openOrder = (item) => {
    if (item.OrderId > 0) {
      props.getOrder(item.OrderId).then((res) => {
        let orderToLoad = {
          ...res.response,
          offerLoaded: res,
        };
        openModalOrder({ mode: Mode.EDIT, order: orderToLoad, type: "Basket" });
      });
    } else {
      props.getAssetInfo({ assetId: item.AssetId }).then((res) => {
        let orderToLoad = {
          ...orderSimple(item),
          ...res.info,
        };
        openModalOrder({ mode: Mode.NEW, order: orderToLoad });
      });
    }
  };

  const changeFilterValue = (props) => {
    setState((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        ...props,
      },
    }));
  };

  return (
    <aside className={`${style.asideContent} aside-menu`}>
      <div className="callout m-0 py-2 text-muted text-center bg-light text-uppercase">
        <small>
          <b>Offers List</b>
        </small>
      </div>
      <div>
        <SearchBox changeValue={changeFilterValue} text={state.filters.text} />
      </div>
      <div className="aside-content">
        <hr className="transparent mx-3 my-0" />
        {itemArray.length === 0 || itemArray === undefined ? (
          <h6 className={style.empty} style={{ textAlign: "center" }}>
            No Offers available
          </h6>
        ) : (
          itemArray &&
          itemArray.map(
            (item) => (
              <Fragment key={`di-${item.OfferId}`}>
                {item.OrderId > 0 ? (
                  <div
                    className={`${style.pointer} callout callout-primary m-0 py-3`}
                    onClick={(e) => openOrder(item)}
                  >
                    <div className="float-right">
                      <Button outline color="primary" className="asideIconBtn">
                        <i className="fa fa-hand-lizard-o" />
                      </Button>
                    </div>
                    <div>
                      {item.AssetName}
                      {" - "}
                      <strong>
                        <FormattedNumber
                          value={item.OfferQuantitytoAdvisor - item.OfferOfferQuantityTakenByAdvisor}
                          dataTypeDecimalName="quantity"
                        />
                      </strong>
                    </div>
                    <small className="text-muted">
                      {" "}
                      - ${" "}
                      <FormattedNumber
                        value={item.OfferPrice}
                        decimalScale={item.SubAssetClassDecimalPlaces}
                        dataTypeDecimalName="price"
                      />
                    </small>
                    <div className="d-flex flex-column">
                      <small className="text-muted">
                        {" "}
                        - Nominal Rate:{" "}
                        <FormattedNumber
                          value={item.NominalRate || 0.0}
                          decimalScale={item.SubAssetClassDecimalPlaces}
                          dataTypeDecimalName="price"
                        />
                      </small>
                      <small className="text-muted">
                        {" "}
                        - XIRR:{" "}
                        <FormattedNumber
                          value={item.XIRR || 0.0}
                          decimalScale={item.SubAssetClassDecimalPlaces}
                          dataTypeDecimalName="price"
                        />
                      </small>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${style.pointer} callout callout-primary m-0 py-3`}
                    onClick={(e) => openOrder(item)}
                  >
                    <div className="float-right">
                      <Button outline color="primary" className="asideIconBtn">
                        <i className="fa fa-hand-lizard-o" />
                      </Button>
                    </div>
                    <div>
                      {item.AssetName}
                      {" - "}
                      <strong>
                        <FormattedNumber
                          value={item.OfferQuantitytoAdvisor - item.OfferOfferQuantityTakenByAdvisor}
                          dataTypeDecimalName="quantity"
                        />
                      </strong>
                    </div>
                    <small className="text-muted">
                      {" "}
                      - ${" "}
                      <FormattedNumber
                        value={item.OfferPrice}
                        decimalScale={item.SubAssetClassDecimalPlaces}
                        dataTypeDecimalName="price"
                      />
                    </small>
                    <div className="d-flex flex-column">
                      <small className="text-muted">
                        {" "}
                        - Nominal Rate:{" "}
                        <FormattedNumber
                          value={item.NominalRate || 0.0}
                          decimalScale={item.SubAssetClassDecimalPlaces}
                          dataTypeDecimalName="price"
                        />
                      </small>
                      <small className="text-muted">
                        {" "}
                        - XIRR:{" "}
                        <FormattedNumber
                          value={item.XIRR || 0.0}
                          decimalScale={item.SubAssetClassDecimalPlaces}
                          dataTypeDecimalName="price"
                        />
                      </small>
                    </div>
                  </div>
                )}

                <hr className="my-0" />
              </Fragment>
            ),
            []
          )
        )}
      </div>
      <button className={style.asideMinimizer} type="button" onClick={props.toggle} />
    </aside>
  );
};

export default Offers;
